var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-loader"},[(_vm.computedSkeleton.cards)?_c('CardsSkeleton',{attrs:{"cards-count":_vm.cardsCount}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }